/**
 * ------------------------------------------------------------
 * Purpose        : Pathname → regional landing config (header label + strip text)
 * ------------------------------------------------------------
 *
 * Pure, server + client safe. Accepts a slug ("lp-nw/mba-rajasthan"), a public
 * path ("/lp-nw/mba-rajasthan/") or the internal rewritten path
 * ("/desktop/in/lp-nw/mba-rajasthan") — all resolve to the same entry.
 */

import { stripDeviceCountry } from "@/features/site-chrome/model/siteLogo";
import type { LandingRegion } from "../model/landingRegion.types";
import { RAJASTHAN_WHY_US_ITEMS } from "./rajasthanWhyUs";

/** Keys are normalized paths: leading slash, no trailing slash, lowercase. */
const LANDING_REGIONS: Record<string, LandingRegion> = {
  "/lp-nw/mba-rajasthan": {
    navLabel: "Rajasthan",
    logoUrl: "https://static.amityonline.com/_s/amity_logo_transparent_619edcf066.webp",
    stripTextHTML:
      "<p>Build your next chapter with Amity Online Jaipur. Explore the Online MBA. Apply Now.</p>",
    qsBadgeText: "Ranked in South Asia",
    showCareerImpact: true,
    showPotentialJobRoles: true,
    whyUsItems: RAJASTHAN_WHY_US_ITEMS,
  },
};

/** Slug or pathname → "/a/b" (query, hash, trailing slash and device/country dropped). */
export function normalizeLandingPath(pathname: string): string {
  const path = pathname.split(/[?#]/)[0].replace(/^\/+|\/+$/g, "");
  return stripDeviceCountry(`/${path}`).toLowerCase();
}

/** Regional config for this page; null → regular landing page. */
export function getLandingRegion(
  pathname: string | null | undefined,
): LandingRegion | null {
  if (!pathname) return null;
  return LANDING_REGIONS[normalizeLandingPath(pathname)] ?? null;
}

export function isRegionalLandingPage(pathname: string | null | undefined): boolean {
  return getLandingRegion(pathname) !== null;
}
